import { recipe } from "@vanilla-extract/recipes";
import { rem } from "@huub-web/utils/css/rem";

import { transition } from "../../../utils/transition";
import { activeState } from "../../../theme/activeState";
import { disabledState } from "../../../theme/disabledState";
import { theme } from "../../../theme/css/theme.css";

export const buttonStyle = recipe({
  base: {
    minWidth: rem(46),
    height: rem(46),
    padding: `${theme.spacings.xs} ${theme.spacings.xs}`,
    position: "relative",
    color: theme.colors.onBackground,
    cursor: "pointer",
    borderRadius: "999px",
    transition: transition("background", "color"),
    selectors: {
      "&:not([disabled]):active": {
        ...activeState,
      },
      "&:not([disabled]):hover": {
        color: theme.colors.onBackground,
      },
    },
  },
  variants: {
    disabled: {
      true: {
        ...disabledState,
      },
    },
    variant: {
      navigation: {},
      ellipsis: {},
      default: {},
    },
    active: {
      true: {
        color: theme.colors.onBackground,
      },
      false: {},
    },
  },
  defaultVariants: {
    active: false,
  },
});

/**
 * Gradient border wrapper - always rendered, opacity controlled by active state
 * Uses an actual div instead of pseudo-elements to avoid rendering bugs
 */
export const gradientBorderStyle = recipe({
  base: {
    position: "absolute",
    top: rem(-1),
    left: rem(-1),
    height: `calc(100% + ${rem(2)})`,
    width: `calc(100% + ${rem(2)})`,
    borderRadius: "inherit",
    background: `linear-gradient(283.85deg, ${theme.colors.gradientD} -0.39%, ${theme.colors.gradientC} 23.95%, ${theme.colors.gradientB} 72.64%)`,
    zIndex: 1,
    opacity: 0,
    transition: transition("opacity"),
  },
  variants: {
    active: {
      true: {
        opacity: 1,
      },
      false: {},
    },
  },
  defaultVariants: {
    active: false,
  },
});

/**
 * Content wrapper that sits above the gradient border
 * Background transitions from tertiary (grey) to background (white) when active
 */
export const contentWrapperStyle = recipe({
  base: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "inherit",
    zIndex: 2,
    transition: transition("background-color"),
    backgroundColor: theme.colors.tertiary,
  },
  variants: {
    active: {
      true: {
        backgroundColor: theme.colors.background,
      },
      false: {},
    },
    variant: {
      navigation: {
        backgroundColor: "transparent",
      },
      ellipsis: {},
      default: {},
    },
  },
  compoundVariants: [
    {
      variants: { active: true, variant: "default" },
      style: { backgroundColor: theme.colors.background },
    },
    {
      variants: { active: true, variant: "ellipsis" },
      style: { backgroundColor: theme.colors.background },
    },
    {
      variants: { active: true, variant: "navigation" },
      style: { backgroundColor: theme.colors.background },
    },
  ],
  defaultVariants: {
    active: false,
    variant: "default",
  },
});

export const buttonContentStyle = recipe({
  base: {
    zIndex: 3,
    color: "currentColor",
    opacity: 0.5,
    transition: transition("opacity"),
    selectors: {
      "button:hover &": {
        opacity: 1,
      },
    },
  },
  variants: {
    active: {
      true: {
        opacity: 0.75,
      },
    },
  },
  defaultVariants: {
    active: false,
  },
});
